export default "__VITE_ASSET__CO8l9ouq__"